const ua = navigator.userAgent.toLowerCase();
const platform = navigator.platform.toLowerCase();
const win = ua.match(/windows/);
const mac = ua.match(/macintosh/);
const googlebot = ua.match(/googlebot/);
const yahoobot = ua.indexOf('y!j') >= 0;
const bingbot = ua.match(/bing/);
const crawlerbot = googlebot || yahoobot || bingbot;

const hasTouch = 'ontouchstart' in window;
const touch = hasTouch && !win;
const desktop = !touch;

const edge = ua.match(/windows/) && ua.match(/edge/);
const ie = ua.match(/msie/) || ua.match(/trident/);
const ie8 = ua.match(/msie 8/);
const ie9 = ua.match(/msie 9/);
const ie10 = ua.match(/msie 10/);
const chrome = ua.match(/chrome/);
const safari = ua.match(/safari/) && !ua.match(/chrome/);
const firefox = ua.match(/firefox/);
const opera = ua.match(/opera/);

const iphone = ua.match(/iphone/);
const ipod = ua.match(/ipod/);
const ipad = ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && touch;
const ios = (iphone || ipod || ipad);

const android = ua.match(/android/);
const androidMobile = android && ua.match(/mobile/);
const androidTablet = android && !(ua.match(/mobile/));
const androidLegacy = ua.match(/android 2|android 4.0|android 4.1|android 4.2|android 4.3/);

let ios_ver = null;
let android_ver = null;
try {
  if (ios) {//2-3桁のverを2桁のfloatに揃える
    ios_ver = (ua.split(' os ')[1] || '').split(' ')[0];
    const v1 = parseInt(ios_ver.split('_')[0]);
    const v2 = parseInt(ios_ver.split('_')[1] || 0);
    ios_ver = parseInt(((v1 < 10 ? '0' : '') + v1 + v2).substr(0, 3)) / 10;
  }
  if (android) {//2桁の整数に揃える
    android_ver = (ua.split('android ')[1] || '').substr(0, 3).split('.').join('');
    android_ver = parseInt(android_ver);
  }
} catch (e) {
  console.error(e);
}

// const iphoneX = window.devicePixelRatio === 3 &&
//   Math.min(window.screen.width, window.screen.height) >= 375 &&
//   /iphone/.test(ua);
const iphoneX = Math.min(window.screen.width, window.screen.height) >= 375 &&
  /iphone/.test(ua);

const macPC = platform === 'macintel';

const mobile = androidMobile || iphone || ipod;
const tablet = androidTablet || ipad;

let retina = (window.devicePixelRatio >= 2);
if (win) retina = false;
let pixelratio = retina ? 2 : 1;
// let pixelratio = retina ? 1.5: 1;
// if(iphone) pixelratio = 2;
// if (android) pixelratio = 1;
// if (tablet) pixelratio = 1;
if (ie) pixelratio = 1;

const canVideoPlaysInline = !!(desktop || (ios && ios_ver >= 100));

const clickEvent = touch ? 'touchend' : 'click';

const jsScroll = !touch;
const noJSScroll = !jsScroll;

export const checkIsPC = () => {
  return window.innerWidth >= 1080;
};
const isPC = checkIsPC();

const LOCAL = location.hostname === 'localhost' || location.hostname.substr(0, 7) === '192.168';

const isFullSpec = !!(desktop || iphoneX);

export default {
  googlebot,
  yahoobot,
  bingbot,
  crawlerbot,
  win,
  mac,
  ie,
  ie8,
  ie9,
  ie10,
  edge,
  chrome,
  safari,
  firefox,
  opera,
  ios,
  iphone,
  iphoneX,
  ipad,
  android,
  androidLegacy,
  androidMobile,
  androidTablet,
  ios_ver,
  android_ver,
  mobile,
  tablet,
  touch,
  desktop,
  retina,
  pixelratio,
  canVideoPlaysInline,
  macPC,
  clickEvent,
  jsScroll,
  noJSScroll,
  isPC,
  isFullSpec,
  LOCAL,
};
